import { useLocation } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import type { AuthStatus } from '../lib/auth';
import { requestSnapshot } from '../lib/requestDiagnostics';
import { useEffect, useRef, useState } from 'react';
import { request } from '../lib/api';
import { feedbackConnectionSnapshot } from '../lib/connectionDiagnostics';
import { Button } from './Button';
import './problem-feedback.css';

export function ProblemFeedback({ taskId }: { taskId?: string }) {
  const cache=useQueryClient();
  const location=useLocation();
  const [open, setOpen] = useState(() => !taskId && location.hash === '#feedback');
  useEffect(()=>{if(!taskId && location.hash==='#feedback') setOpen(true);},[location.hash,taskId]);
  const [note, setNote] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [feedbackId, setFeedbackId] = useState('');
  const submitting = useRef(false);
  async function submit() {
    if (submitting.current) return;
    submitting.current = true;
    setBusy(true); setError('');
    try {
      const browserLogs = await feedbackConnectionSnapshot();
      let requestLogs;
      if(cache.getQueryData<AuthStatus>(['auth-status'])?.user?.feedbackSchemaVersion===1){
        try {
        const health=await request<{client_version?:string}>('/health');
        const version=health.client_version?.split('.').map(Number);
        if(version?.length===3&&version[0]===2&&(version[1]>1||version[1]===1&&version[2]>=130)) requestLogs=requestSnapshot();
        } catch { /* Explicit feedback still uses the original supported fields. */ }
      }
      const result = await request<{ feedback_id: string }>('/client-feedback', {
        method: 'POST', body: JSON.stringify({ note, ...(taskId ? { task_id: taskId } : {}),
          ...(browserLogs.length ? {browser_logs: browserLogs} : {}),
          ...(requestLogs ? {request_logs:requestLogs} : {}) }),
      });
      setFeedbackId(result.feedback_id);
    } catch (reason) {
      setError(reason instanceof Error ? reason.message : '提交失败，请稍后手动重试。');
    } finally { submitting.current = false; setBusy(false); }
  }
  return <section aria-label="问题反馈">
    <Button variant="secondary" onClick={() => setOpen(value => !value)} aria-expanded={open}>反馈问题</Button>
    {open ? <div className="feedback-form">
      <p>提交版本、手机状态和脱敏诊断记录，不含截图、聊天或评论内容。</p>
      {feedbackId ? <p role="status">已收到，我们会尽快查看。反馈编号：<code>{feedbackId}</code></p> : <>
        <label>补充说明（选填，最多200字；请勿填写手机号或客户内容）
          <textarea aria-label="补充说明" value={note} maxLength={200} disabled={busy}
            onChange={event => setNote(event.target.value)} rows={3}/>
        </label>
        <p>{note.length}/200</p>
        {error ? <p role="alert">{error} 本次不会自动重传。</p> : null}
        <Button loading={busy} disabled={busy} onClick={() => void submit()}>提交反馈</Button>
      </>}
    </div> : null}
  </section>;
}
